import { z } from 'zod'
import type { StandardObservation } from '../../models/StandardObservations'
import { BaseCompanyDTO, mapBaseCompanyToDTO, mapDTOToBaseCompany } from '~/domain/shared/company/gateways/DTOs/BaseCompanyDTO'

export const StandardObservationUserDTO = z.object({
  id: z.number().optional(),
  name: z.string().nullish(),
  email: z.string().nullish()
})

export type StandardObservationUserDTO = z.infer<typeof StandardObservationUserDTO>

export const StandardObservationDTO = z.object({
  id: z.number().optional(),
  title: z.string(),
  description: z.string().nullish(),
  user: StandardObservationUserDTO.nullish(),
  company: BaseCompanyDTO.nullish()
})

export type StandardObservationDTO = z.infer<typeof StandardObservationDTO>

export function mapStandardObservationToDTO (model: StandardObservation): StandardObservationDTO {
  return {
    id: model.id,
    title: model.title,
    description: model.description,
    user: model.user
      ? {
          id: model.user.id,
          name: model.user.name,
          email: model.user.email
        }
      : undefined,
    company: model.company ? mapBaseCompanyToDTO(model.company) : undefined
  }
}

export function mapDTOToStandardObservation (dto: StandardObservationDTO): StandardObservation {
  return {
    id: dto.id,
    title: dto.title,
    description: dto.description ?? undefined,
    user: dto.user
      ? {
          id: dto.user.id,
          name: dto.user.name ?? '',
          email: dto.user.email ?? ''
        }
      : undefined,
    company: dto.company
      ? {
          ...mapDTOToBaseCompany(dto.company),
          companyName: typeof dto.company !== 'number' ? dto.company.company_name ?? undefined : undefined
        }
      : undefined
  }
}
